import { render } from "./ProfileIcon.vue?vue&type=template&id=675d41c0"
import script from "./ProfileIcon.vue?vue&type=script&lang=js"
export * from "./ProfileIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__